import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    overflow: 'visible',
  },
  button: {
    margin: theme.spacing(1),
  },
  createSubtaskButton: {
    minHeight: 42,
    margin: theme.spacing(0, 0, 1.5),
    padding: theme.spacing(0.75, 2),
    borderRadius: 14,
    textTransform: 'none',
    fontWeight: 700,
    letterSpacing: '0.01em',
    background: 'linear-gradient(135deg, #2563eb 0%, #3b82f6 52%, #60a5fa 100%)',
    boxShadow: '0 14px 30px rgba(37, 99, 235, 0.24)',
    transition:
      'transform 180ms ease, box-shadow 180ms ease, border-color 180ms ease, background-color 180ms ease',
    '&:hover': {
      transform: 'translateY(-1px)',
      boxShadow: '0 10px 18px rgba(15, 23, 42, 0.1)',
    },
  },
  leftIcon: {
    marginRight: theme.spacing(1),
  },
  table: {
    marginTop: 0,
  },
  sectionGrid: {
    alignItems: 'stretch',
  },
  tablePanel: {
    height: '100%',
    borderRadius: 24,
    border: '1px solid rgba(37, 99, 235, 0.1)',
    background:
      'linear-gradient(180deg, rgba(255,255,255,0.98) 0%, rgba(248,250,252,0.96) 100%)',
    boxShadow: '0 18px 40px rgba(15, 23, 42, 0.08)',
    overflow: 'hidden',
  },
  tablePanelContent: {
    padding: theme.spacing(2),
    '&:last-child': {
      paddingBottom: theme.spacing(2),
    },
  },
  tableHeader: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  tableEyebrow: {
    fontSize: '0.72rem',
    fontWeight: 700,
    letterSpacing: '0.18em',
    textTransform: 'uppercase',
    color: '#2563eb',
    marginBottom: theme.spacing(0.5),
  },
  tableTitle: {
    fontWeight: 700,
    color: '#0f172a',
    lineHeight: 1.2,
  },
  tableSubtitle: {
    color: '#64748b',
    marginTop: theme.spacing(0.5),
    maxWidth: 560,
  },
  tableBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 34,
    padding: theme.spacing(0.75, 1.5),
    borderRadius: 999,
    fontSize: '0.78rem',
    fontWeight: 700,
    letterSpacing: '0.04em',
    color: '#1d4ed8',
    background: 'rgba(37, 99, 235, 0.08)',
    border: '1px solid rgba(37, 99, 235, 0.14)',
  },
  tableScroller: {
    width: '100%',
    overflowX: 'auto',
    borderRadius: 18,
    border: '1px solid rgba(148, 163, 184, 0.14)',
    backgroundColor: 'rgba(255,255,255,0.82)',
  },
  subtaskTableScroller: {
    width: '100%',
    overflowX: 'auto',
    borderRadius: 12,
    border: '1px solid rgba(148, 163, 184, 0.14)',
    backgroundColor: 'rgba(255,255,255,0.82)',
  },
  headerRow: {
    background:
      'linear-gradient(180deg, rgba(219,234,254,0.9) 0%, rgba(239,246,255,0.98) 100%)',
    boxShadow: 'inset 0 -1px 0 rgba(96, 165, 250, 0.24)',
  },
  headerCell: {
    '&.MuiTableCell-head': {
      background:
        'linear-gradient(180deg, rgba(219,234,254,0.88) 0%, rgba(239,246,255,0.98) 100%)',
      color: '#0b111f',
      fontSize: '0.75rem',
      fontWeight: 800,
      letterSpacing: '0.14em',
      borderBottom: '1px solid rgba(96, 165, 250, 0.24)',
    },
  },
  headerCheckboxCell: {
    '&.MuiTableCell-head': {
      background:
        'linear-gradient(180deg, rgba(191,219,254,0.92) 0%, rgba(219,234,254,0.98) 100%)',
    },
  },
  tableCheckbox: {
    color: 'rgba(37, 99, 235, 0.42)',
    '&.Mui-checked': {
      color: '#2563eb',
    },
    '&:hover': {
      backgroundColor: 'rgba(37, 99, 235, 0.08)',
    },
  },
  dataTable: {
    minWidth: 880,
    borderCollapse: 'separate',
    borderSpacing: 0,
    '& .MuiTableCell-head': {
      paddingTop: theme.spacing(1.5),
      paddingBottom: theme.spacing(1.5),
      borderBottom: '1px solid rgba(148, 163, 184, 0.14)',
      backgroundColor: 'rgba(248,250,252,0.96)',
      color: '#475569',
      fontSize: '0.74rem',
      fontWeight: 800,
      letterSpacing: '0.12em',
      textTransform: 'uppercase',
      whiteSpace: 'nowrap',
    },
    '& .MuiTableCell-body': {
      borderBottom: '1px solid rgba(226, 232, 240, 0.8)',
      color: '#0f172a',
      verticalAlign: 'middle',
    },
    '& .MuiTableRow-root:last-child .MuiTableCell-body': {
      borderBottom: 'none',
    },
  },
  dataRow: {
    transition: 'background-color 160ms ease, transform 160ms ease',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'rgba(239, 246, 255, 0.72)',
    },
  },
  selectedRow: {
    background:
      'linear-gradient(135deg, rgba(236,253,245,0.96) 0%, rgba(209,250,229,0.9) 100%) !important',
    boxShadow: 'inset 4px 0 0 #10b981',
  },
  stickyActionBar: {
    marginBottom: theme.spacing(1.5),
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
  },
  actionToolbarButton: {
    minHeight: 42,
    padding: theme.spacing(0.75, 1.75),
    borderRadius: 14,
    textTransform: 'none',
    fontWeight: 700,
    boxShadow: '0 10px 20px rgba(37, 99, 235, 0.14)',
  },
  rowPrimaryText: {
    fontWeight: 700,
    color: '#0f172a',
  },
  rowSecondaryText: {
    color: '#64748b',
    fontSize: '0.82rem',
  },
  indexBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 28,
    height: 28,
    borderRadius: 999,
    background: 'rgba(37, 99, 235, 0.08)',
    color: '#1d4ed8',
    fontSize: '0.78rem',
    fontWeight: 700,
  },
  statusPill: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: theme.spacing(0.6, 1.1),
    borderRadius: 999,
    background: 'rgba(15, 23, 42, 0.06)',
    color: '#334155',
    fontSize: '0.78rem',
    fontWeight: 700,
    whiteSpace: 'nowrap',
  },
  timelineButton: {
    minHeight: 38,
    padding: theme.spacing(0.5, 1.25),
    borderRadius: 12,
    textTransform: 'none',
    fontWeight: 700,
    boxShadow: 'none',
    border: '1px solid rgba(148, 163, 184, 0.18)',
    background: 'rgba(255,255,255,0.88)',
    '&:hover': {
      background: '#ffffff',
    },
  },
  detailColumn: {
    display: 'grid',
    gap: theme.spacing(2),
  },
  infoCard: {
    borderRadius: 20,
    border: '1px solid rgba(148, 163, 184, 0.14)',
    background:
      'linear-gradient(180deg, rgba(255,255,255,0.98) 0%, rgba(248,250,252,0.96) 100%)',
    boxShadow: '0 14px 32px rgba(15, 23, 42, 0.06)',
    overflow: 'hidden',
  },
  infoCardContent: {
    padding: theme.spacing(1.5),
    '&:last-child': {
      paddingBottom: theme.spacing(1.5),
    },
  },
  customInput: {
    '& .MuiOutlinedInput-adornedStart': {
      paddingLeft: '8px', // ปรับ padding-left เป็น 8px
    },
    '& .MuiOutlinedInput-root': {
      fontSize: '13px', // เพิ่มขนาด font
      transition: 'box-shadow 0.3s ease-in-out',
      '& fieldset': {
        borderWidth: '1px', // กำหนดขนาดเส้นขอบเป็น 1px
      },
      '&:hover fieldset': {
        borderWidth: '1px', // ให้ขนาดขอบคงที่ตอน hover
        borderColor: '#1565c0', // เปลี่ยนสีขอบให้เข้ากับเงา
      },
      '&.Mui-focused fieldset': {
        borderWidth: '1px', // ให้ขนาดขอบคงที่ตอน focus
        borderColor: '#1565c0', // เปลี่ยนสีขอบให้เข้ากับเงา
      },
      '&.Mui-focused': {
        boxShadow: '0 0 8px rgba(33, 150, 243, 0.6)', // สีฟุ้งตอน focus
        backgroundColor: '#fafafa',
      },
    },
    marginTop: '4px',
    marginBottom: '8px',
  },
  stepperCard: {
    borderRadius: 20,
    border: '1px solid rgba(37, 99, 235, 0.12)',
    background:
      'linear-gradient(180deg, rgba(255,255,255,0.98) 0%, rgba(248,250,252,0.96) 100%)',
    boxShadow: '0 16px 36px rgba(15, 23, 42, 0.08)',
    overflow: 'hidden',
  },
  stepperCardContent: {
    padding: theme.spacing(2.5),
    '&:last-child': {
      paddingBottom: theme.spacing(2.5),
    },
  },
  stepperHeader: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  stepperEyebrow: {
    fontSize: '0.72rem',
    fontWeight: 700,
    letterSpacing: '0.18em',
    textTransform: 'uppercase',
    color: '#2563eb',
    marginBottom: theme.spacing(0.5),
  },
  stepperTitle: {
    fontWeight: 700,
    color: '#0f172a',
    lineHeight: 1.2,
  },
  stepperSubtitle: {
    color: '#64748b',
    marginTop: theme.spacing(0.5),
    maxWidth: 520,
  },
  stepperBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 34,
    padding: theme.spacing(0.75, 1.5),
    borderRadius: 999,
    fontSize: '0.78rem',
    fontWeight: 700,
    letterSpacing: '0.04em',
    color: '#1d4ed8',
    background: 'rgba(37, 99, 235, 0.08)',
    border: '1px solid rgba(37, 99, 235, 0.14)',
  },
  stepperTrack: {
    padding: theme.spacing(2, 1.5, 1.25),
    borderRadius: 18,
    background:
      'linear-gradient(180deg, rgba(239,246,255,0.92) 0%, rgba(255,255,255,0.92) 100%)',
    border: '1px solid rgba(191, 219, 254, 0.9)',
  },
  stepperRoot: {
    padding: 0,
    borderRadius: 16,
    background: 'rgba(255, 255, 255, 0.58)',
    backdropFilter: 'blur(10px)',
    '& .MuiStepConnector-alternativeLabel': {
      top: 15,
      left: 'calc(-50% + 22px)',
      right: 'calc(50% + 22px)',
    },
    '& .MuiStepConnector-line': {
      borderTopWidth: 3,
      borderRadius: 999,
      borderColor: 'rgba(191, 219, 254, 0.95)',
    },
    '& .MuiStepConnector-active .MuiStepConnector-line, & .MuiStepConnector-completed .MuiStepConnector-line': {
      borderColor: '#2563eb',
    },
  },
  stepIconRoot: {
    width: 32,
    height: 32,
    color: '#cbd5e1',
    '& text': {
      fill: '#475569',
      fontSize: '0.78rem',
      fontWeight: 700,
    },
  },
  stepIconActive: {
    color: '#2563eb',
    filter: 'drop-shadow(0 6px 14px rgba(37, 99, 235, 0.24))',
  },
  stepIconCompleted: {
    color: '#1d4ed8',
  },
  stepIconText: {
    fill: '#ffffff !important',
    fontWeight: 700,
  },
  stepLabelText: {
    display: 'inline-block',
    marginTop: theme.spacing(0.5),
    fontSize: '0.78rem',
    fontWeight: 700,
    lineHeight: 1.35,
    color: '#475569',
    textAlign: 'center',
  },
  stepperItemPanel: {
    marginTop: theme.spacing(1.75),
    padding: theme.spacing(1.5, 1.75),
    borderRadius: 16,
    background:
      'linear-gradient(135deg, rgba(255,255,255,0.95) 0%, rgba(248,250,252,0.92) 100%)',
    border: '1px solid rgba(148, 163, 184, 0.16)',
  },
  stepperItemLabel: {
    fontSize: '0.72rem',
    fontWeight: 700,
    letterSpacing: '0.14em',
    textTransform: 'uppercase',
    color: '#64748b',
    marginBottom: theme.spacing(0.5),
  },
  stepperItemValue: {
    fontWeight: 700,
    color: '#0f172a',
    wordBreak: 'break-word',
  },
}));

export default useStyles;
